import { Component, type ReactNode, type ErrorInfo } from "react";


interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-background flex items-center justify-center p-4">
          <div className="text-center max-w-md">
            <h1 className="text-3xl font-bold mb-4 text-foreground">משהו השתבש</h1>
            <p className="text-muted-foreground mb-6">אירעה שגיאה בלתי צפויה. נסו לרענן את הדף.</p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                onClick={() => window.location.reload()}
                className="bg-accent text-accent-foreground px-6 py-3 rounded-xl font-bold hover:opacity-90 transition-opacity min-h-[48px]"
              >
                רענן את הדף
              </button>
              <a
                href="/"
                className="border border-border text-foreground px-6 py-3 rounded-xl font-bold hover:bg-muted transition-colors min-h-[48px] inline-flex items-center justify-center"
              >
                חזרה לדף הבית
              </a>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
